
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"20","width":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.833 16.292l-4.937-4.938q-.625.479-1.375.74-.75.26-1.479.26-1.834 0-3.104-1.271Q3.667 9.812 3.667 8q0-1.812 1.271-3.083 1.27-1.271 3.083-1.271 1.812 0 3.094 1.271Q12.396 6.188 12.396 8q0 .792-.281 1.542-.282.75-.74 1.312l4.958 4.958zm-7.791-4.604q1.541 0 2.614-1.063T11.729 8q0-1.562-1.073-2.625T8.042 4.312q-1.563 0-2.636 1.063Q4.333 6.438 4.333 8t1.073 2.625q1.073 1.063 2.636 1.063z"}})])
          )
        }
      }
    